import { render, staticRenderFns } from "./ColumnList.vue?vue&type=template&id=4e1ddc23&scoped=true&"
import script from "./ColumnList.vue?vue&type=script&lang=js&"
export * from "./ColumnList.vue?vue&type=script&lang=js&"
import style0 from "./ColumnList.vue?vue&type=style&index=0&id=4e1ddc23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1ddc23",
  null
  
)

export default component.exports